const adaptUnidad = (unidad) => {
  const { idUnidad, descripcion, alias, activo } = unidad;

  return {
    id: idUnidad,
    displayName: descripcion,
  };
};

export const adaptUnidades = (data) => {
  return (
    data?.unidades?.valorEsperado?.map((unidad) => adaptUnidad(unidad)) || []
  );
};
